import React, { useState, useEffect } from "react";
import ReactModal from "react-modal";
import JSONPretty from "react-json-pretty";
import "./show-response.scss";

const ShowResponse = (props) => {
    const submittedServices = props.submittedFilesHistory?.filter(
        (val) => val.service == props.service,
    );
    return (
        <>
            <ReactModal
                isOpen={props.show}
                className="show-response-modal application-page"
            >
                <div className="modal-header">
                    <h4 className="text-left">Response</h4>
                </div>
                <div className="modal-body">
                    {!!submittedServices &&
                        submittedServices?.length > 0 &&
                        submittedServices?.map((service) => (
                            <>
                                <div className="row">
                                    <div className="col-6 col-md-6">
                                        <h5>Submitted Data</h5>
                                        <JSONPretty
                                            id="json-pretty"
                                            data={JSON.parse(service.data)}
                                        ></JSONPretty>
                                    </div>
                                    <div className="col-6 col-md-6">
                                        <h5>Response</h5>
                                        <JSONPretty
                                            id="json-pretty"
                                            data={JSON.parse(service.response)}
                                        ></JSONPretty>
                                    </div>
                                </div>
                                <hr />
                            </>
                        ))}
                </div>
                <div className="modal-footer">
                    <button
                        type="button"
                        className="btn confirm-button btn-danger"
                        onClick={() => props.onClose()}
                    >
                        Close
                    </button>
                </div>
            </ReactModal>
        </>
    );
};

export default ShowResponse;
